/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { RenewRequestDto } from '../model/renewRequestDto';
import { ServiceSubscriptionDto } from '../model/serviceSubscriptionDto';
import { ServiceSubscriptionHistoryModel } from '../model/serviceSubscriptionHistoryModel';
import { ServiceSubscriptionModel } from '../model/serviceSubscriptionModel';
import { SubscriptionDistributionReportResponse } from '../model/subscriptionDistributionReportResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsServiceSubscriptionService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsServiceSubscriptionDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsServiceSubscriptionDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsServiceSubscriptionDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/SmsServiceSubscription/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param startIndex 
     * @param count 
     * @param searchword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionGetAll(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetAll(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriptionModel>>>;
    public smsServiceSubscriptionGetAll(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriptionModel>>>;
    public smsServiceSubscriptionGetAll(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceSubscriptionModel>>(`${this.basePath}/api/SmsServiceSubscription/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param startIndex 
     * @param count 
     * @param searchword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionGetAllActive(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetAllActive(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriptionModel>>>;
    public smsServiceSubscriptionGetAllActive(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriptionModel>>>;
    public smsServiceSubscriptionGetAllActive(phoneNumber?: string, startIndex?: number, count?: number, searchword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceSubscriptionModel>>(`${this.basePath}/api/SmsServiceSubscription/GetAllActive`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param startIndex 
     * @param count 
     * @param searchword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionGetAllByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetAllByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriptionModel>>>;
    public smsServiceSubscriptionGetAllByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriptionModel>>>;
    public smsServiceSubscriptionGetAllByCreatorId(creatorId?: string, startIndex?: number, count?: number, searchword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceSubscriptionModel>>(`${this.basePath}/api/SmsServiceSubscription/GetAllByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionGetByCreatorId(creatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriptionModel>;
    public smsServiceSubscriptionGetByCreatorId(creatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetByCreatorId(creatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetByCreatorId(creatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceSubscriptionModel>(`${this.basePath}/api/SmsServiceSubscription/GetByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param serviceName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionGetByCreatorIdAndServiceName(phoneNumber?: string, serviceName?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriptionModel>;
    public smsServiceSubscriptionGetByCreatorIdAndServiceName(phoneNumber?: string, serviceName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetByCreatorIdAndServiceName(phoneNumber?: string, serviceName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetByCreatorIdAndServiceName(phoneNumber?: string, serviceName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceSubscriptionModel>(`${this.basePath}/api/SmsServiceSubscription/GetByCreatorIdAndServiceName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionGetById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriptionModel>;
    public smsServiceSubscriptionGetById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceSubscriptionModel>(`${this.basePath}/api/SmsServiceSubscription/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param shortCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionGetFirstOrDefault(phoneNumber?: string, shortCode?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriptionModel>;
    public smsServiceSubscriptionGetFirstOrDefault(phoneNumber?: string, shortCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetFirstOrDefault(phoneNumber?: string, shortCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriptionModel>>;
    public smsServiceSubscriptionGetFirstOrDefault(phoneNumber?: string, shortCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceSubscriptionModel>(`${this.basePath}/api/SmsServiceSubscription/GetFirstOrDefault`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionInsert(model: ServiceSubscriptionDto, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscriptionDto>;
    public smsServiceSubscriptionInsert(model: ServiceSubscriptionDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscriptionDto>>;
    public smsServiceSubscriptionInsert(model: ServiceSubscriptionDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscriptionDto>>;
    public smsServiceSubscriptionInsert(model: ServiceSubscriptionDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsServiceSubscriptionInsert.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ServiceSubscriptionDto>(`${this.basePath}/api/SmsServiceSubscription/Insert`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionRenewal(model: RenewRequestDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsServiceSubscriptionRenewal(model: RenewRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsServiceSubscriptionRenewal(model: RenewRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsServiceSubscriptionRenewal(model: RenewRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsServiceSubscriptionRenewal.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/SmsServiceSubscription/Renewal`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param serviceId 
     * @param creatorId 
     * @param shortcode 
     * @param phoneNumber 
     * @param includeExpiredSubscription 
     * @param mnc 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionSubscriberDistributionReport(startDate?: Date, endDate?: Date, serviceId?: string, creatorId?: string, shortcode?: string, phoneNumber?: string, includeExpiredSubscription?: boolean, mnc?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<SubscriptionDistributionReportResponse>;
    public smsServiceSubscriptionSubscriberDistributionReport(startDate?: Date, endDate?: Date, serviceId?: string, creatorId?: string, shortcode?: string, phoneNumber?: string, includeExpiredSubscription?: boolean, mnc?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriptionDistributionReportResponse>>;
    public smsServiceSubscriptionSubscriberDistributionReport(startDate?: Date, endDate?: Date, serviceId?: string, creatorId?: string, shortcode?: string, phoneNumber?: string, includeExpiredSubscription?: boolean, mnc?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriptionDistributionReportResponse>>;
    public smsServiceSubscriptionSubscriberDistributionReport(startDate?: Date, endDate?: Date, serviceId?: string, creatorId?: string, shortcode?: string, phoneNumber?: string, includeExpiredSubscription?: boolean, mnc?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (shortcode !== undefined && shortcode !== null) {
            queryParameters = queryParameters.set('shortcode', <any>shortcode);
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (includeExpiredSubscription !== undefined && includeExpiredSubscription !== null) {
            queryParameters = queryParameters.set('includeExpiredSubscription', <any>includeExpiredSubscription);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SubscriptionDistributionReportResponse>(`${this.basePath}/api/SmsServiceSubscription/SubscriberDistributionReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionSubscriptionHistory(phoneNumber?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscriptionHistoryModel>>;
    public smsServiceSubscriptionSubscriptionHistory(phoneNumber?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscriptionHistoryModel>>>;
    public smsServiceSubscriptionSubscriptionHistory(phoneNumber?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscriptionHistoryModel>>>;
    public smsServiceSubscriptionSubscriptionHistory(phoneNumber?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceSubscriptionHistoryModel>>(`${this.basePath}/api/SmsServiceSubscription/SubscriptionHistory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortcode 
     * @param unsubscriptionKeyword 
     * @param msisdn 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionUnsubscribeService(shortcode?: string, unsubscriptionKeyword?: string, msisdn?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsServiceSubscriptionUnsubscribeService(shortcode?: string, unsubscriptionKeyword?: string, msisdn?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsServiceSubscriptionUnsubscribeService(shortcode?: string, unsubscriptionKeyword?: string, msisdn?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsServiceSubscriptionUnsubscribeService(shortcode?: string, unsubscriptionKeyword?: string, msisdn?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortcode !== undefined && shortcode !== null) {
            queryParameters = queryParameters.set('shortcode', <any>shortcode);
        }
        if (unsubscriptionKeyword !== undefined && unsubscriptionKeyword !== null) {
            queryParameters = queryParameters.set('unsubscriptionKeyword', <any>unsubscriptionKeyword);
        }
        if (msisdn !== undefined && msisdn !== null) {
            queryParameters = queryParameters.set('msisdn', <any>msisdn);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/SmsServiceSubscription/UnsubscribeService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsServiceSubscriptionUpdate(model: ServiceSubscriptionModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsServiceSubscriptionUpdate(model: ServiceSubscriptionModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsServiceSubscriptionUpdate(model: ServiceSubscriptionModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsServiceSubscriptionUpdate(model: ServiceSubscriptionModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsServiceSubscriptionUpdate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/SmsServiceSubscription/Update`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
